module.exports = __webpack_public_path__ + "img/hr-level3addon_running.cce00587.png";